import * as swcHelpers from '@swc/helpers';
import { useMutation } from '@grandvisionhq/graphql';
import { UPDATE_PERSONAL_DETAILS } from '../../operations/mutations/update-personal-details.js';

const useUpdatePreferredStore = ({ onError , onCompleted  })=>{
    var ref;
    const [mutationCallback, mutation] = useMutation(UPDATE_PERSONAL_DETAILS, {
        onCompleted,
        onError (error) {
            onError === null || onError === void 0 ? void 0 : onError(error, 'stores.storeDetailsRoot.preferredStoreUpdate.error');
        }
    });
    var _preferredStore;
    return {
        data: (_preferredStore = mutation === null || mutation === void 0 ? void 0 : (ref = mutation.data) === null || ref === void 0 ? void 0 : ref.updateB2CPersonalDetails.preferredStore) !== null && _preferredStore !== void 0 ? _preferredStore : null,
        loading: mutation === null || mutation === void 0 ? void 0 : mutation.loading,
        error: mutation === null || mutation === void 0 ? void 0 : mutation.error,
        updatePersonalDetails: function() {
            var _ref = swcHelpers.asyncToGenerator(function*(preferredStoreCode, userId) {
                yield mutationCallback({
                    variables: {
                        customerId: userId,
                        input: {
                            preferredStore: preferredStoreCode
                        }
                    }
                });
            });
            return function(preferredStoreCode, userId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
var useUpdatePreferredStore$1 = useUpdatePreferredStore;

export { useUpdatePreferredStore$1 as default };
//# sourceMappingURL=use-update-preferred-store.js.map
